<template>
  <BonatitanNav>エラー</BonatitanNav>
  <section class="l-section--form --ta-center mt-lg">
    <BonatitanOutputField>{{ statusMessage }}</BonatitanOutputField>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-html="props.error?.message" />
  </section>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { computed } from 'vue'

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})

const defaultStatusMessage = computed(() => {
  switch (props.error.statusCode) {
    case 408:
      return 'タイムアウトしました。'
    case 409:
      return 'リクエストが競合しました。'
    case 118:
      return 'リクエストが無効です。'
    default:
      return 'エラーが発生しました。'
  }
})
const statusMessage = computed(() => props.error.statusMessage || defaultStatusMessage.value)
</script>

<style scoped lang="scss">
p {
  color: var(--c-text);
}

</style>
